import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  events = 'events',
  event = 'event',
}

enum ExternalRoutesIds {
  entity = 'entity',
  entities = 'entities',
}

// root route
export const eventsRouteRef = createRouteRef({ id: RoutesIds.events });

export const rootRouteRef = eventsRouteRef;

// sub-routes within the plugin
export const eventRouteRef = createSubRouteRef({
  id: RoutesIds.event,
  parent: rootRouteRef,
  path: '/:id',
});

// external routes to other plugins
export const entityRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entity,
  params: ['id'],
  optional: true,
});

export const entitiesRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.entities,
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  events: eventsRouteRef,
  event: eventRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  // external routes to other plugins
  entity: entityRouteRef,
  entities: entitiesRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
